export enum EErrorCode {
  EMPTY_PACKAGE = 'EMPTY_PACKAGE',
  BIN = 'BIN Error',
  SHORT_LINK_ERROR = 'SHORT_LINK_ERROR',
  ERR_BAD_REQUEST = 'ERR_BAD_REQUEST',
  TIME_OUT = 'ECONNABORTED',
  DEFAULT_ERROR = 'UNKNOWN_ERROR'
}
